/**
 * MapStatus — loading/error status indicator.
 */

import React from 'react';

interface MapStatusProps {
  loading?: boolean;
  error?: string | null;
}

export default function MapStatus({ loading, error }: MapStatusProps) {
  if (!loading && !error) return null;

  return (
    <div className="flex items-center gap-2 bg-white/95 rounded-lg shadow-md border border-slate-200 px-3 py-2">
      {loading && (
        <>
          <div className="w-4 h-4 animate-spin rounded-full border-2 border-emerald-600 border-t-transparent" />
          <span className="text-xs text-slate-600">Loading map data...</span>
        </>
      )}
      {error && !loading && (
        <>
          <span className="text-sm">⚠️</span>
          <span className="text-xs text-red-600 max-w-48 truncate">{error}</span>
        </>
      )}
    </div>
  );
}
